import { IonIcon, IonItem, IonText } from '@ionic/react';
import { lockClosed } from 'ionicons/icons';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useToastQueue from '../../../utils/useToastQueue';

interface SortMenuItemProps {
  /** The list's task order is locked by a manager (List.taskOrderLocked). */
  isLocked: boolean;
  /** Opens the sort action sheet. Only called when the order is not locked. */
  onOpenSort: () => void;
}

/**
 * "Sort by..." row for the list-details popover menus. When a manager has locked the task order the row stays visible
 * with a lock icon; tapping it presents a short toast explaining the lock instead of opening the sort sheet (CC-1886).
 * Callers keep their own hasMoreThanOneTask / QM-list gating.
 */
const SortMenuItem: React.FC<SortMenuItemProps> = ({ isLocked, onOpenSort }) => {
  const { t } = useTranslation();
  const [presentToast] = useToastQueue();

  const onClick = () => {
    if (isLocked) {
      presentToast({ message: t('list.lockedOrder.toast'), duration: 2500, position: 'bottom' });
    } else {
      onOpenSort();
    }
  };

  return (
    <IonItem lines="none" onClick={onClick} data-testid="sort-menu-item">
      <IonText>{t('menu.action.sort')}</IonText>
      {isLocked && (
        <IonIcon
          slot="end"
          icon={lockClosed}
          color="medium"
          className="font-20"
          aria-label={t('list.lockedOrder.iconLabel')}
          data-testid="sort-menu-item-lock"
        />
      )}
    </IonItem>
  );
};

export default SortMenuItem;
